import { FC } from "react"
import { Icon, IconColor } from "@/components/shared/Icon"
import "./index.scss"

const SUPPORT_PHONE = "844-373-2778"

const LoginSupport: FC = () => {
   return (
      <div className="support">
         <div className="support-text">
            For support questions contact us at:
         </div>
         <div className="support-phone">
            <Icon
               name="support"
               color={IconColor.WHITE}
               size="16"
            />
            <span>{SUPPORT_PHONE}</span>
         </div>
         <div className="support-email">
            <Icon
               name="envelope"
               color={IconColor.WHITE}
               size="16"
            />
            <a href="mailto:support@rs.care">support@rs.care</a>
         </div>
      </div>
   )
}

export default LoginSupport
